import { Button, Form, Input } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { openNotification } from '../../utils';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const onFinish = (values: { email: string }) => {
        setLoading(true);

        const userData = {
            email: values.email,
        };

        const apiUrl = process.env.REACT_APP_API_BASE_URL + '/auth/reset-password-requests';

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: apiUrl,
            data: userData,
        };

        axios
            .request(config)
            .then((response: any) => {
                console.log(response);
                openNotification('success', 'Başarılı', 'E-Posta adresinizi kontrol ediniz.');
                // Yönlendirme ve e-postayı URL parametresi olarak ekleme
                navigate(`/forgot-password-confirm?email=${encodeURIComponent(values.email)}`);
                setLoading(false);
            })
            .catch((e: Error) => {
                console.log(e);
                openNotification('error', 'Başarısız', 'E-Posta adresiniz doğru değil! Kontrol ederek tekrar deneyin.');
                setLoading(false);
            });
    };

    return (
        <section>
            <h2 className="auth-card-title">Şifremi Unuttum</h2>
            <p className="auth-card-description">
                Şifrenizi sıfırlamak için kullandığınız e-posta adresini girin. Size bir bağlantı göndereceğiz.
            </p>
            <Form
                name="email_form"
                className="auth-card-form"
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    label="E-posta"
                    name="email"
                    rules={[
                        { required: true, message: 'Lütfen e-posta adresinizi girin.' },
                        { type: 'email', message: 'Geçerli bir e-posta adresi girin.' },
                    ]}
                >
                    <Input size="large" className="form-input" placeholder="ornek@eposta.com" />
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" loading={loading} size="large" block type="primary">
                        Gönder
                    </Button>
                </Form.Item>
            </Form>
            <p className="auth-card-footer">
                Şifrenizi biliyor musunuz? <Link to="/giris">Giriş Yap</Link>
            </p>
        </section>
    );
};

export default ForgotPassword;
